// extracted by mini-css-extract-plugin
export default {"audioButton":"AudioPlayer_audioButton__RKgCO"};